import type { FC } from 'react';

import { redirectTo } from '@xing-com/crate-core-router';
import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { useHost } from '@xing-com/crate-xinglet';
import { useFeatureSwitch } from '@xing-com/hub';

import { FollowedCompanies } from '../followed-companies/followed-companies';

export const FollowedCompaniesRoute: FC = () => {
  const { isLoggedIn } = useLoginState();
  const host = useHost();
  const showNewLoggedInOverview = useFeatureSwitch(
    'enable_new_logged_in_companies_overview'
  );

  if (!isLoggedIn) {
    return host.redirectToLogin('/companies/my_companies_follow');
  }

  if (showNewLoggedInOverview) {
    return redirectTo('/companies');
  }

  return <FollowedCompanies />;
};
